<template>
  <div class="mainIndex" :style="`background-image:url(${bgcImgUrl})`"></div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      bgcImgUrl: "",
    };
  },
  created() {
    if (localStorage.getItem("lang")) {
      this.getAccessToken();
      this.openFullScreen2();
    } else {
      this.getLang();
      this.getAccessToken();
      this.openFullScreen2();
    }
  },
  beforeDestroy() {
    this.$loading().close();
  },
  methods: {
    // 获取当前的语言版本
    getLang() {
      let success = res => {
        // console.log(res.data.default_lang)
        this.$i18n.locale = res.data.default_lang;
        Cookies && Cookies?.set('think_var', res.data.default_lang)
        localStorage.setItem('lang', res.data.default_lang)
      };
      this.$ajax.get("api/login/get_default_lang", {
        params: {},
        func: { success: success }
      });
    },
    getScene() {
      const success = (res) => {
        let number1 = res.data - 1;
        sessionStorage.setItem("isItcScene", number1);
        this.$store.commit("SET_ISITCSCENCE", number1);
        // window.location.href = window.location.origin + "/user-login";
        this.$router.replace({path: '/user-login'})
        if (number1) {
          // 修改element ui 主题颜色
          // this.toggleClass(document.body,'custom-E62125')
        } else {
          // this.toggleClass(document.body,'custom-409EFF')
        }
      };
      const fail = (res) => { };
      this.$ajax.get("api/login/frontVersion", { func: { success, fail } });
    },
    getAccessToken() {
      this.$ajax
        .get("/accessToken", {
          params: {
            company: "BL",
            device_name: "TE-0600R",
            data: {
              client_id: "20882088",
              secret: "nGk5R2wrnZqQ02bed29rjzax1QWRIu1O",
            },
          },
        })
        .then((response) => {
          localStorage.setItem("access_token", response.data.data.access_token);
          this.getBackgroudPic();
        });
    },
    getBackgroudPic() {
      let success = (res) => {
        this.bgcImgUrl = this.BASE_URL + res.data.back_image;
        this.getLoginType();
      };
      this.$ajax({
        url: "api/system/login_set",
        method: "get",
        params: {},
        func: { success: success },
      });
    },
    openFullScreen2() {
      this.$loading({
        lock: false,
        text: "Loading....",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        color: "white",
      });
    },
    getLoginType() {
      let success = (res) => {
        let data = res.data;
        let userinfo
        // 防止第一次进入该页面session中不存在此数据
        if (sessionStorage.getItem('user_info_str')) {
          userinfo = JSON.parse(sessionStorage.getItem('user_info_str'))
        }
        
        if (userinfo) {
          let first_login = userinfo.first_login
          if (first_login == 1) {
            return this.getScene();
          }
        }


        if (data == "1") {
          let token = localStorage.getItem("token");
          if (token) {
            window.location.href = window.location.origin + "/homeindex";
          } else {
            this.getScene();
          }
        } else {
          window.location.href = window.location.origin + "/homeindex";
        }
      };
      let fail = (res) => {
        window.location.href = window.location.origin;
      };
      this.$ajax({
        url: `api/login/loginType`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          DecisionPlatform: "logintable",
        },
        method: "get",
        func: {
          success,
          fail,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.mainIndex {
  margin: 0;
  padding: 0;
  border: none;
  height: 100vh;
  width: 100vw;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.el-loading-spinner {
  background: rgba(0, 0, 0, 0);
  border-radius: 8px;
  text-align: center;
  font-size: 40px;

  i {
    color: #eee;
  }

  .el-loading-text {
    color: #eee;
  }
}
</style>